module.exports = __webpack_public_path__ + "media/images/main/bg-gradient-ee53c974d60a80e61de3a9b18ecc8b76.png";